import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { BlogRedirectGuard } from "@core-guards/blog-redirect.guard";
import { LandingRedirectGuard } from "@core-guards/landing-redirect.guard";
import { CanActivateView } from "@core-guards/maintenance-page.guard";
import { AdditionalSettingResolver } from "@core-resolvers/additional-settings.resolver";
import { AboutComponent } from "./about/about.component";
import { DirectiveCommitteeComponent } from "./about/directive-committee/directive-committee.component";
import { LegalNoticeComponent } from "./about/legal-notice/legal-notice.component";
import { PaymentMethodsComponent } from "./about/payment-methods/payment-methods.component";
import { ServicesPoliciesComponent } from "./about/services-policies/services-policies.component";
import { WhoWeAreComponent } from "./about/who-we-are/who-we-are.component";
import { ContactUsComponent } from "./help/contact-us/contact-us.component";
import { FaqsComponent } from "./help/faqs/faqs.component";
import { HelpMainComponent } from "./help/help-main/help-main.component";
import { HelpTopicsComponent } from "./help/help-topics/help-topics.component";
import { HelpComponent } from "./help/help.component";
import { HomeComponent } from "./home/home.component";
import { AkkyProComponent } from "./landings/akky-pro/akky-pro.component";
import { DealsComponent } from "./landings/deals/deals.component";
import { DigitizeComponent } from "./landings/digitize/digitize.component";
import { PackageDealsComponent } from "./landings/package-deals/package-deals.component";
import { PersonalBrandComponent } from "./landings/personal-brand/personal-brand.component";
import { PymesComponent } from "./landings/pymes/pymes.component";
import { MainComponent } from "./layouts/main/main.component";
import { MaintenanceComponent } from "./layouts/maintenance/maintenance.component";
import { AdditionalPurchaseSuggestionComponent } from "./purchase-suggestion/additional-purchase-suggestion.component";
import { DudaComponent } from "./services/duda/duda.component";
import { EmailServiceComponent } from "./services/email/email-service.component";
import { HostingServiceComponent } from "./services/hosting/hosting-service.component";
import { RegisterDomainsComponent } from "./services/search-domains/register-domains/register-domains.component";
import { ServicesComponent } from "./services/services.component";
import { SslCertificateServiceComponent } from "./services/ssl-certificate/ssl-certificate-service.component";
import { TransferInServiceComponent } from "./services/transfer-in/transfer-in-service.component";
import { WordPressServiceComponent } from "./services/wordpress/wordpress-service.component";
import { UserEsuAccessComponent } from "./user-access/user-esu-access/user-esu-access.component";
import { MadeInMexicoComponent } from "./landings/made-in-mexico/made-in-mexico.component";
import { MadeInMexicoDataComponent } from "./landings/made-in-mexico/made-in-mexico-data/made-in-mexico-data.component";
import { MadeInMexicoDataResolver } from "@core-resolvers/MadeInMexicoDataResolver";
import { MadeInMexicoDataGuard } from "@core-guards/made-in-mexico-data.guard";
import { InitiativesComponent } from "./landings/initiatives/initiatives.component";
import { InitiativesDataComponent } from "./landings/initiatives/initiatives-data/initiatives-data.component";
import { InitiativesDataGuard } from "@core-guards/initiatives-data.guard";
import { InitiativesDataResolver } from "@core-resolvers/initiatives.resolver";


const routes: Routes = [
  {
    path: '',
    component: MainComponent,
    canActivate: [CanActivateView],
    children: [
      {
        path: '',
        component: HomeComponent
      },
      {
        path: 'esuaccess',
        component: UserEsuAccessComponent
      },
      //Help
      {
        path: 'ayuda',
        component: HelpComponent,
        children: [
          {
            path: 'contacto',
            component: ContactUsComponent
          },
          {
            path: 'ayuda',
            component: HelpMainComponent
          },
          {
            path: 'faq',
            component: FaqsComponent
          },
          {
            path: 'temas-de-ayuda',
            component: HelpTopicsComponent
          },
          {
            path: 'comunicacion/avisos',
            canActivate: [BlogRedirectGuard]
          }
        ]
      },
      {
        path: 'boletin',
        canActivate: [BlogRedirectGuard]
      },
      //About
      {
        path: 'acerca',
        component: AboutComponent,
        children: [
          {
            path: 'quienes-somos',
            component: WhoWeAreComponent
          },
          {
            path: 'nuestroequipo',
            component: DirectiveCommitteeComponent
          },
          {
            path: 'comite-directivo',
            component: DirectiveCommitteeComponent,
            canActivate: [LandingRedirectGuard]
          },
          {
            path: 'politicas-de-servicios',
            component: ServicesPoliciesComponent
          },
          {
            path: 'formas-de-pago',
            component: PaymentMethodsComponent
          },
          {
            path: 'aviso-legal',
            component: LegalNoticeComponent
          }
        ]
      },
      //Services
      {
        path: 'servicios',
        component: ServicesComponent,
        children: [
          {
            path: 'dominios',
            component: RegisterDomainsComponent
          },
          {
            path: 'transferencias',
            component: TransferInServiceComponent
          },
          {
            path: 'email',
            component: EmailServiceComponent
          },
          {
            path: 'hosting',
            component: HostingServiceComponent
          },
          {
            path: 'certificados-ssl',
            component: SslCertificateServiceComponent
          },
          {
            path: 'wordpress/:type',
            component: WordPressServiceComponent
          },
          {
            path: 'creador-de-sitios-web',
            component: DudaComponent
          }
        ]
      },
      {
        path: 'promociones',
        component: DealsComponent
      },
      {
        path: 'paquetes',
        component: PackageDealsComponent
      },
      {
        path: 'recomendaciones',
        component: AdditionalPurchaseSuggestionComponent,
        resolve: {
          data: AdditionalSettingResolver
        }
      },
      {
        path: 'iniciativas',
        component: InitiativesComponent
      },
      {
        path: 'iniciativas-datos',
        component: InitiativesDataComponent,
        resolve: {
          data: InitiativesDataResolver
        },
        canActivate: [InitiativesDataGuard]
      },
      {
        path: 'iniciativas',
        component: InitiativesComponent
      },
      {
        path: 'iniciativas-datos',
        component: InitiativesDataComponent,
        resolve: {
          data: InitiativesDataResolver
        },
        canActivate: [InitiativesDataGuard]
      },
      {
        path: 'akkypro',
        component: AkkyProComponent
      }
    ]
  },
  {
    path: 'mimarcapersonal', //Redirige a Digitalizate
    component: PersonalBrandComponent,
    canActivate: [LandingRedirectGuard]
  },
  {
    path: 'digitalizate',
    component: DigitizeComponent
  },
  {
    path: 'emprendeconakky', //Regirige a Digitalizatepyme
    component: PymesComponent,
    canActivate: [LandingRedirectGuard]
  },
  {
    path: 'digitalizatepyme',
    component: PymesComponent
  },
  {
    path: 'maintenance',
    component: MaintenanceComponent
  },
  {
    path: "**",
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking',
    scrollPositionRestoration: 'enabled'
  })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
